import AppLayout from '@/layouts/AppLayout.vue'
import NotFound from '@/pages/NotFoundView.vue'
import Unauthorized from '@/pages/UnauthorizedView.vue'
import { routeAlias, routeNames, routePaths } from '@/router/router-constants'
import { apbRoutes } from '@/router/routes/apb-routes'
import { caseRoutes } from '@/router/routes/case-routes'
import { courtRoutes } from '@/router/routes/court-routes'
import { deadlineRoutes } from '@/router/routes/deadline-routes'
import { emailCampaignRoutes } from '@/router/routes/email-campaign-routes'
import { massiveEmailRoutes } from '@/router/routes/massive-email-routes'
import { massiveImportRoutes } from '@/router/routes/massive-import-routes'
import { pctRoutes } from '@/router/routes/pct-routes'
import { personRoutes } from '@/router/routes/person-routes'
import { portfolioRoutes } from '@/router/routes/portfolio-routes'
import { practiceRoutes } from '@/router/routes/practice-routes'
import { practiceTypeRoutes } from '@/router/routes/practice-type-routes'
import { recordTypeRoutes } from '@/router/routes/record-type-routes'
import { reportRoutes } from '@/router/routes/report-routes'
import { roleRoutes } from '@/router/routes/role-routes'
import { settingRoutes } from '@/router/routes/setting-routes'
import { subjectTypeRoutes } from '@/router/routes/subject-type-routes'
import { taskRoutes } from '@/router/routes/task-routes'
import { taskTypeRoutes } from '@/router/routes/task-type-routes'
import { toolRunsRoutes } from '@/router/routes/tool-runs-routes'
import { userRoutes } from '@/router/routes/user-routes'
import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: routePaths.homeLayout,
    name: routeNames.homeLayout,
    component: AppLayout,
    alias: routeAlias.homeLayout,
    children: [
      {
        path: routePaths.home,
        name: routeNames.home,
        component: () => import('@/pages/home/HomeView.vue'),
        meta: { icon: 'pi pi-home', labelKey: 'home' },
      },
      {
        path: routePaths.profile,
        name: routeNames.profile,
        component: () => import('@/pages/profile/MyProfileView.vue'),
        meta: { labelKey: 'profile' },
      },
      {
        path: routePaths.unauthorized,
        name: routeNames.unauthorized,
        component: Unauthorized,
        meta: {
          labelKey: 'unauthorized',
        },
      },
      ...apbRoutes,
      ...caseRoutes,
      ...courtRoutes,
      ...deadlineRoutes,
      ...emailCampaignRoutes,
      ...massiveEmailRoutes,
      ...massiveImportRoutes,
      ...pctRoutes,
      ...personRoutes,
      ...portfolioRoutes,
      ...practiceRoutes,
      ...practiceTypeRoutes,
      ...recordTypeRoutes,
      ...reportRoutes,
      ...roleRoutes,
      ...settingRoutes,
      ...subjectTypeRoutes,
      ...taskRoutes,
      ...taskTypeRoutes,
      ...toolRunsRoutes,
      ...userRoutes,
    ],
  },
  {
    path: routePaths.login,
    name: routeNames.login,
    component: () => import('@/pages/auth/LoginView.vue'),
    alias: routeAlias.login,
    meta: { publicRoute: true },
  },
  {
    path: routePaths.firstPasswordChange,
    name: routeNames.firstPasswordChange,
    component: () => import('@/pages/auth/FirstPasswordChangeView.vue'),
    meta: { publicRoute: true },
  },
  {
    path: routePaths.notFound,
    name: routeNames.notFound,
    component: NotFound,
    meta: { publicRoute: true },
  },
]
